// nothing references these libraries directly so we need to load them here

require('angular-ui-router');
require('ngreact');
require('animate.css');
require('../vendor/file-api/dist/FileAPI.flash.swf');
var URI = require('URIjs');

(function() {
    Octopus.App = angular.module('octopusApp', [
        'ngRoute',
        'ngAnimate',
        'ngSanitize',
        'ngStorage',
        'ui.bootstrap',
        'ui.select',
        'ui.sortable',
        'ui.ace',
        'ui.router',
        'frapontillo.bootstrap-switch',
        'autofill-directive',
        'angularFileUpload',
        'react',
        'octopusApp.infrastructure',
        'octopusApp.shared',
        'octopusApp.master',
        'octopusApp.dashboard',
        'octopusApp.projects',
        'octopusApp.tasks',
        'octopusApp.users',
        'octopusApp.configuration',
        'octopusApp.library',
        'octopusApp.environments',
        'octopusApp.management',
        'octopusApp.accounts',
        'octopusApp.tenants'
    ]).config(function($routeProvider) {

    }).config(function(uiSelectConfig) {
        uiSelectConfig.theme = 'select2';
    }).config(function ($uibTooltipProvider) {
        //TODO: ui-bootstrap has bug whereby popover-append-to-body="true" is not being respected
        $uibTooltipProvider.options({ appendToBody: true });
    }).config(function (uiAceConfig) {
        var options = uiAceConfig.ace || {};
        options.useWrapMode = false;
        options.showGutter = true;
        options.theme = 'textmate';
        uiAceConfig.ace = options;
    }).run(function($rootScope, $state, $localStorage, octopusClient) {
        $rootScope.octopusVersion = octopusClient.rootDocument().Version;
        $rootScope.isEarlyAccessProgram = octopusClient.rootDocument().IsEarlyAccessProgram || false;
        $rootScope.$storage = $localStorage.$default({});
        $rootScope.ExtensionsCSS = octopusClient.rootDocument().ExtensionsCSS;
        $rootScope.ExtensionsJavascript = octopusClient.rootDocument().ExtensionsJavascript;
        $rootScope.pageTitle = "Home";

        // Synchronize some navigation properties with the current route
        $rootScope.$on('$stateChangeSuccess', function() {

            // Ensure all inherited layout data is added to $rootscope for view rendering
            if ($state.current) {
                $rootScope.layout = {};
                Object.keys($state.$current.includes).forEach(function(a) {
                    _.assign($rootScope.layout, ($state.get(a)|| {}).layout);
                }, $rootScope);

                $rootScope.pageTitle = $rootScope.layout.title;
            }

            $("#dynamicallyGeneratedContent").empty();
        });
    }).config(function($stateProvider, $urlMatcherFactoryProvider, $urlRouterProvider) {
        $urlMatcherFactoryProvider.caseInsensitive(true);
        $urlMatcherFactoryProvider.strictMode(false);
        //$urlRouterProvider.when('', '/');

        $stateProvider.state('app', {
            state: 'app',
            name: 'Application',
            redirectTo: 'app.dashboard',
            templateUrl: 'areas/master/views/layout.html',
            data: {
                layoutType: 'full'
            },
            controller: function($rootScope, $state){
                $rootScope.$state = $state;
            }
        });

        $stateProvider.state("app.not-found", {
            url: "*path",
            templateUrl: "areas/shared/views/not-found.html"
        });
    });

    // We defer startup of Angular until we've established a connection to Octopus
    Octopus.App.start = function() {
        $(function(){
            var body = $("body");
            var navMain = $("#main-navbar");

            navMain.on("click", "a:not(.dropdown-toggle)", null, function (e) {
                $("#main-navbar-collapse").collapse('hide');
            });

            var loader = $('#initial-page-loader');
            var connecting = $('.when-connecting', loader);
            var loadingMessage = $('.loading-message', connecting);
            var progressBar = $('.progress', connecting);
            var failed = $('.connection-failed', loader);
            var whyFailed = $('p.why', failed);
            var tryAgain = $('button.try-again', failed);

            tryAgain.click(function() {
                location.reload();
            });

            var configuration = {};
            var serverUri = URI(window.location);
            serverUri.hasQuery("octopus.server", function (baz) {
                configuration.serverEndpoint = baz;
            });

            Octopus.App.Client = new Octopus.Client.OctopusClient(configuration);

            Octopus.App.resolveLink = function(link) {
                return Octopus.App.Client.resolve(link);
            };

            var loadScripts = function(remainingScripts, onComplete) {
                if (remainingScripts.length === 0) {
                    onComplete();
                    return;
                }
                var js = remainingScripts[0];
                $.getScript(Octopus.App.Client.resolve(js))
                    .done(function(script) {
                        remainingScripts.shift();
                        loadScripts(remainingScripts, onComplete);
                    });
            };

            Octopus.App.Client.connect(function (progress, indicator) {
                loadingMessage.text(progress);
                progressBar.removeClass("progress-success");
                progressBar.removeClass("progress-warning");
                progressBar.removeClass("progress-danger");
                progressBar.addClass("progress-" + indicator);
            }).then(function () {

                loadScripts(Octopus.App.Client.rootDocument().ExtensionsJavascript, function () {

                    _.forEach(Octopus.App.Client.rootDocument().ExtensionAngularModules, function (m) {
                        Octopus.App.requires.push(m);
                    });

                    var repository = new Octopus.Client.Repository(Octopus.App.Client);
                    repository.Users.getCurrent().then(function(user) {
                        return repository.Users.getPermissions(user).then(function(permissionSet){
                            loader.remove();

                            Octopus.App.currentUser = user;
                            Octopus.App.currentPermissionSet = permissionSet.Permissions;

                            body.addClass("initialized");
                            angular.bootstrap(document, ['octopusApp']);
                        });
                    }).catch(function (err) {
                        if (err.StatusCode === 401) {
                            loader.remove();
                            body.addClass("initialized");
                            angular.bootstrap(document, ['octopusApp']);
                            return;
                        }

                        whyFailed.text(err.ErrorMessage);
                        connecting.hide();
                        failed.removeClass('hide');
                        failed.show();
                    });
                });
            }).catch(function (err) {
                whyFailed.text(err.ErrorMessage);
                if (err.Errors.length > 0) {
                    whyFailed.text(err.Errors[0]);
                }
                connecting.hide();
                failed.removeClass('hide');
                failed.show();
            });
        });
    };
})();



//////////////////
// WEBPACK FOOTER
// ./app/app.js
// module id = 369
// module chunks = 1